/* ELURA option panel — drives the theme's hidden native <select> so price,
   availability and the Purchase/Inquire button keep working unchanged. */
(function () {
  if (customElements.get('elura-option-panel')) return;

  class EluraOptionPanel extends HTMLElement {
    connectedCallback() {
      this.kind = this.dataset.kind;
      this.label = this.dataset.label;
      this.select = document.getElementById(this.dataset.select);
      this.trigger = this.querySelector('.elura-panel-trigger');
      this.triggerLabel = this.querySelector('.elura-panel-trigger__label');
      this.triggerValue = this.querySelector('.elura-panel-trigger__value');
      this.panel = this.querySelector('.elura-panel');
      this.overlay = this.querySelector('.elura-panel__overlay');
      this.rows = Array.from(this.querySelectorAll('.elura-panel__row'));
      this.confirm = this.querySelector('[data-panel-confirm]');
      this.confirmText = this.querySelector('.elura-panel__confirm-text');
      this.selected = null;

      if (!this.select) return;

      // Hide the native control (keep it in the DOM for the theme JS).
      const native = this.select.closest('fieldset, .product-form__input');
      if (native) native.classList.add('elura-native-hidden');

      // Portal the drawer to <body> so it escapes the product column's stacking context.
      document.body.appendChild(this.overlay);
      document.body.appendChild(this.panel);

      this.trigger.addEventListener('click', () => this.open());
      // Close controls live inside the portaled drawer/overlay — query them there, not on `this`.
      this.overlay.addEventListener('click', () => this.close());
      this.panel.querySelectorAll('[data-panel-close]').forEach(el => el.addEventListener('click', e => { e.preventDefault(); this.close(); }));
      this.rows.forEach(row => row.addEventListener('click', () => this.choose(row.dataset.value)));
      if (this.confirm) this.confirm.addEventListener('click', () => this.confirmChoice());
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && this.isOpen()) this.close(); });

      // Gate the main button: no selection yet → open the panel instead.
      this.gate = e => {
        const btn = e.target.closest('#AddToCart');
        if (!btn || this.selected) return;
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        this.open();
      };
      document.addEventListener('click', this.gate, true);

      // Match the main button's horizontal geometry at every breakpoint (theme bleeds it on mobile).
      this.syncGeometry();
      this.onResize = () => { clearTimeout(this.rt); this.rt = setTimeout(() => this.syncGeometry(), 80); };
      window.addEventListener('resize', this.onResize);

      // Shade rows by stock: darker = in stock for the current metal.
      this.variantSelects = this.closest('variant-selects') || document.querySelector('variant-selects');
      this.loadVariants();
      this.markAvailability();
      if (this.variantSelects) this.variantSelects.addEventListener('change', () => setTimeout(() => this.markAvailability(), 30));

      // Keep confirm text in sync with the main button (PURCHASE / INQUIRE).
      this.syncConfirm();
      this.observer = new MutationObserver(() => this.syncConfirm());
      const addBtn = document.getElementById('AddToCart');
      if (addBtn) this.observer.observe(addBtn, { attributes: true, subtree: true, childList: true, characterData: true });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.gate, true);
      window.removeEventListener('resize', this.onResize);
      if (this.observer) this.observer.disconnect();
      if (this.overlay && this.overlay.parentNode === document.body) this.overlay.remove();
      if (this.panel && this.panel.parentNode === document.body) this.panel.remove();
    }

    isOpen() { return !this.panel.hidden; }

    open() {
      this.panel.hidden = false;
      this.overlay.hidden = false;
      setTimeout(() => { this.panel.classList.add('is-open'); this.overlay.classList.add('is-open'); }, 20);
      this.trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('elura-panel-lock');
      const current = this.rows.find(r => r.classList.contains('is-selected'));
      if (current) current.scrollIntoView({ block: 'center' });
    }

    close() {
      this.panel.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('elura-panel-lock');
      setTimeout(() => { this.panel.hidden = true; this.overlay.hidden = true; }, 220);
    }

    choose(value) {
      this.selected = value;
      this.dataset.selected = value;
      this.rows.forEach(r => {
        const on = r.dataset.value === value;
        r.classList.toggle('is-selected', on);
        r.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      // Drive the native select → theme updates price / availability / button.
      if (this.select.value !== value) {
        this.select.value = value;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.triggerLabel.textContent = this.label;
      this.triggerValue.textContent = value;
      this.triggerValue.hidden = false;
      this.trigger.classList.add('has-value');
      if (this.confirm) this.confirm.disabled = false;
      setTimeout(() => this.syncConfirm(), 50);
      // One tap = chosen: close the drawer after a beat so the highlight registers.
      if (this.isOpen()) setTimeout(() => this.close(), 180);
    }

    confirmChoice() {
      if (!this.selected) return;
      this.close();
      const addBtn = document.getElementById('AddToCart');
      if (addBtn) setTimeout(() => addBtn.click(), 240);
    }

    syncGeometry() {
      const b = document.getElementById('AddToCart');
      if (!b || !this.trigger) return;
      const cs = getComputedStyle(b);
      const ml = parseFloat(cs.marginLeft) || 0, mr = parseFloat(cs.marginRight) || 0;
      this.trigger.style.setProperty('margin-left', ml + 'px', 'important');
      this.trigger.style.setProperty('margin-right', mr + 'px', 'important');
      this.trigger.style.setProperty('width', (ml || mr) ? 'calc(100% + ' + (-(ml + mr)) + 'px)' : '100%', 'important');
    }

    loadVariants() {
      this.variants = null; this.optionIndex = -1; this.optionSelects = [];
      if (!this.variantSelects || !this.variantSelects.contains(this.select)) return;
      const s = this.variantSelects.querySelector('script[type="application/json"]');
      try { this.variants = JSON.parse(s.textContent); } catch (e) { this.variants = null; }
      this.optionSelects = Array.from(this.variantSelects.querySelectorAll('select'));
      this.optionIndex = this.optionSelects.indexOf(this.select);
    }

    markAvailability() {
      if (!this.variants || this.optionIndex < 0) { this.rows.forEach(r => r.classList.add('is-available')); return; }
      const others = this.optionSelects.map((sel, i) => i === this.optionIndex ? null : sel.value);
      this.rows.forEach(r => {
        const v = r.dataset.value;
        const ok = this.variants.some(va => va.available && va.options[this.optionIndex] === v && others.every((o, i) => o === null || va.options[i] === o));
        r.classList.toggle('is-available', ok);
      });
    }

    syncConfirm() {
      const addBtn = document.getElementById('AddToCart');
      if (!addBtn || !this.confirmText) return;
      const span = addBtn.querySelector('.single-add-to-cart-button--text');
      const text = (span && (span.dataset.content || span.textContent) || 'PURCHASE').trim();
      this.confirmText.textContent = text.toUpperCase();
    }
  }

  customElements.define('elura-option-panel', EluraOptionPanel);
})();

/* ELURA text line-item (Name): match PURCHASE geometry + gate the button until it's filled */
(function () {
  function field() { return document.querySelector('fieldset.product-information--line-item input[type="text"][required]'); }
  function sync() {
    var f = field(), b = document.getElementById('AddToCart'); if (!f || !b) return;
    var cs = getComputedStyle(b), ml = parseFloat(cs.marginLeft) || 0, mr = parseFloat(cs.marginRight) || 0;
    f.style.setProperty('margin-left', ml + 'px', 'important'); f.style.setProperty('margin-right', mr + 'px', 'important');
    f.style.setProperty('width', (ml || mr) ? 'calc(100% + ' + (-(ml + mr)) + 'px)' : '100%', 'important');
  }
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(sync, 80); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  setTimeout(sync, 400);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#AddToCart'); if (!btn) return;
    var f = field(); if (!f || f.value.trim()) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    f.scrollIntoView({ block: 'center', behavior: 'smooth' });
    f.classList.remove('is-missing'); void f.offsetWidth; f.classList.add('is-missing');
    setTimeout(function () { f.focus(); }, 250);
  }, true);
  document.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('fieldset.product-information--line-item input[type="text"]')) e.target.classList.remove('is-missing'); });
})();
